<form
  *ngIf="selectedSupportItem"
  [formGroup]="form"
  (ngSubmit)="saveConnecting()"
  class="detail">
  <div class="detail__head">
    <h2 class="detail__head-headline">{{ "SUPPORT_PAGE.ID_NUMBER" | translate }}: {{ selectedSupportItem.support_id }}</h2>
    <div
      [class.process]="selectedSupportItem.status === 'PROCESS'"
      [class.new]="selectedSupportItem.status === 'NEW'"
      [class.reviewed]="selectedSupportItem.status === 'REVIEWED'"
      class="detail__head-status">
      <span
        *ngIf="selectedSupportItem.status === 'PROCESS'"
        class="name">
        {{ "SUPPORT_PAGE.IN_PROCESS" | translate }}
      </span>
      <span
        *ngIf="selectedSupportItem.status === 'NEW'"
        class="name">
        {{ "SUPPORT_PAGE.NEW" | translate }}
      </span>
      <span
        *ngIf="selectedSupportItem.status === 'REVIEWED'"
        class="name">
        {{ "SUPPORT_PAGE.REVIEWED" | translate }}
      </span>
    </div>

    <ng-container *appHasAccess="['SUPPORT_EDIT']">
      <button
        *ngIf="!isEditSupport && this.selectedSupportItem?.status === 'NEW'"
        (click)="toggleEdit()"
        class="btn-icon">
        <img
          src="assets/img/edit-icon.svg"
          class="btn-icon__image" />
      </button>
    </ng-container>
  </div>
  <div class="detail__body">
    <div class="detail__body-line">
      <div class="left">{{ "SUPPORT_PAGE.SUPPORT_TYPE" | translate }}</div>
      <div class="right select">
        <app-form-custom-select
          formControlName="typeFormControl"
          [itemList]="supportTypeList">
        </app-form-custom-select>
      </div>
    </div>
    <div class="detail__body-line">
      <div class="left">{{ "SUPPORT_PAGE.DATE" | translate }}</div>
      <div class="right">
        {{ selectedSupportItem.date }}
      </div>
    </div>
    <div class="detail__body-line">
      <div class="left">{{ "SUPPORT_PAGE.USER" | translate }}</div>
      <div class="right">
        {{ selectedSupportItem.full_name }}
      </div>
    </div>
    <div class="detail__body-message">
      <div
        [class.error]="form.get('commentFormControl')?.invalid && form.get('commentFormControl')?.touched"
        class="input-block textarea">
        <textarea
          formControlName="commentFormControl"
          maxlength="1000"
          id="comment"
          class="input"
          placeholder=" ">
        </textarea>
        <label
          for="comment"
          class="placeholder">
          {{ "SUPPORT_PAGE.MESSAGE" | translate }} *
        </label>
        <ng-container *ngIf="form.get('commentFormControl')?.invalid && form.get('commentFormControl')?.touched">
          <span
            *ngIf="commentRequiredError"
            class="input-block__error">
            {{ "SUPPORT_PAGE.MODAL.ERROR.COMMENT_REQUIRED" | translate }}
          </span>
        </ng-container>

        <ng-container *ngIf="!(form.get('commentFormControl')?.invalid && form.get('commentFormControl')?.touched)">
          <span class="input-block__count">
            <span *ngIf="!form.controls['commentFormControl'].value">0</span>
            <span *ngIf="form.controls['commentFormControl'].value">
              {{ form.controls["commentFormControl"].value.length }}
            </span>
            / 1000
          </span>
        </ng-container>
      </div>
    </div>
    <div
      *ngIf="selectedSupportItem.answer"
      class="detail__body-response">
      <p class="title">{{ "SUPPORT_PAGE.RESPONSE" | translate }}:</p>
      <textarea
        [value]="selectedSupportItem.answer"
        readonly
        class="message">
      </textarea>
    </div>

    <div
      *ngIf="selectedSupportItem.file_attached.length !== 0"
      class="detail__body-files">
      <p class="title">{{ "SUPPORT_PAGE.ATTACHED_FILES" | translate }}</p>
      <ul class="file-list">
        <li
          *ngFor="let item of selectedSupportItem.file_attached"
          (click)="downloadFile(item.id)"
          class="file-list__item">
          {{ item.file_name }}
        </li>
      </ul>
    </div>

    <ng-container *ngIf="isEditSupport">
      <div
        id="files"
        class="form-frame__body-file">
        <ngx-file-drop
          dropZoneLabel="Drop files here"
          (onFileDrop)="dropped($event)"
          (onFileOver)="fileOver($event)"
          (onFileLeave)="fileLeave($event)">
          <ng-template
            ngx-file-drop-content-tmp
            let-openFileSelector="openFileSelector">
            <button
              (click)="openFileSelector()"
              type="button"
              class="download-btn">
              <img
                src="assets/img/attach.svg"
                alt="Attach"
                class="download-btn__image" />
              <span class="download-btn__content">
                {{ "AGREEMENT.ATTACH" | translate }}
                <span class="download-btn__content-description">
                  {{ "AGREEMENT.DRUG_AND_DROP" | translate }}
                </span>
              </span>
            </button>
          </ng-template>
        </ngx-file-drop>
      </div>
      <ul class="form-frame__body-attach-list">
        <li
          class="file-item"
          *ngFor="let item of files; let i = index">
          {{ item.relativePath }}
          <button
            (click)="deleteFile(i)"
            class="file-item__delete"></button>
        </li>
      </ul>
    </ng-container>
  </div>
  <div
    *ngIf="isEditSupport"
    class="detail__btn-block">
    <button
      [disabled]="form.invalid || isSending"
      type="submit"
      class="btn btn-accent">
      {{ "SUPPORT_PAGE.SAVE" | translate }}
    </button>
    <button
      (click)="toggleEdit()"
      type="button"
      class="btn btn-light">
      {{ "SUPPORT_PAGE.CANCEL" | translate }}
    </button>
  </div>
</form>
